export const InputMaxLength = {
    SMALL_TEXT: 75,
    STANDARD_TEXT: 150,
    DESCRIPTION: 150,
    SMALL_TEXT_AREA: 255,
    STANDARD_TEXT_AREA: 500,
    LONG_TEXT_AREA: 900,
    FIFTY_CHARACTERS_TEXT: 50,
}